import { render, staticRenderFns } from "./AttendanceUsingElectronicCommunication.vue?vue&type=template&id=f56524fa"
import script from "./AttendanceUsingElectronicCommunication.vue?vue&type=script&lang=ts"
export * from "./AttendanceUsingElectronicCommunication.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports